module.exports = __webpack_public_path__ + "img/foreword_4.3c062232.jpg";